import {Controller} from "@hotwired/stimulus"
import React from "react";
import {createRoot} from 'react-dom/client';
import Excalidraw from "../components/Excalidraw";

// Connects to data-controller="excalidraw"
export default class extends Controller {
  static values = {id: Number, content: Object}

  connect() {
    this.root = createRoot(this.element);
    console.log(this.contentValue);

    this.root.render(<Excalidraw id={this.idValue} initialData={this.contentValue}/>);
  }

  disconnect() {
    // Limpa o root React quando o controller é desconectado pelo Turbo
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}
